export class CollageFilterModel {
  todayDate = new Date();

  // startDate = new Date(2016, 0, 1);
  // startDateMs = new Date(2016, 0, 1).getTime();

  // endDate = this.todayDate;
  endDateMs = this.todayDate.getTime();
  startDateMs = new Date().setDate(this.todayDate.getDate() - 30);

  _startDate: Date;
  _endDate: Date;

  sortType: string = 'Descending';
  description: string = '';

  fetchCount = -1;

  constructor() {
    this.startDate = new Date(this.startDateMs);
    this.endDate = new Date(this.endDateMs);
  }

  set startDate(date: Date) {
    this._startDate = date;
    this.startDateMs = date.getTime();
  }

  get startDate() {
    return this._startDate;
  }

  set endDate(date: Date) {
    this._endDate = date;
    this.endDateMs = date.getTime();
  }

  get endDate() {
    return this._endDate;
  }
}
